<template>
    <h1 class="text-2xl font-semibold text-gray-900"><slot></slot></h1>
</template>
